import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  paper: {
    minWidth: 180,
    maxWidth: 192,
    maxHeight: 200,
    borderRadius: 6,
    boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.4)"
  },
  button: {
    width: "100%",
    height: 50,
    maxHeight: 50,
    padding: "0 12px",
    textTransform: "capitalize",
    whiteSpace: "nowrap",
    borderBottom: "1px solid #eeeeee",
    "& .MuiButton-label": {
      justifyContent: "flex-start"
    },
    "& .MuiButton-iconSizeMedium > *:first-child": {
      fontSize: 16
    },
    "& .MuiButton-startIcon": {
      margin: 0,
      position: "relative",
      bottom: 1
    }
  },
  icon: {
    marginRight: 8
  },
  assignIcon: {
    color: "rgba(66, 105, 181, 1)"
  },
  completeIcon: {
    color: "rgba(97, 198, 158, 1)",
    maxHeight: 14
  },
  undoCompleteIcon: {
    color: "#d92e44",
    opacity: 0.6,
    transform: "scaleX(-1)"
  },
  reopenIcon: {
    color: "#ccc3b2"
  },
  closeIcon: {
    color: "#998765"
  },
  detailsIcon: {
    color: "rgba(51, 51, 51, 1)"
  }
}));
